import {
  GetSecondAgreementText,
  getAgreements,
  getAuthLink,
  getPeps,
  getCities,
  getCountries,
  geCreditDebitCountries,
  submitForm,
  submitPIForm,
  sendSmsTanCode,
  getFullCountries,
  GetMonthlyTurnovers,
  getPepCategory,
  getBanks,
  getPurposes,
  GetPropertieSources,
  verifyIdentity,
} from "./common/sharedServices";
import {
  localToken,
  // getCookieValue,
  getInstance,
  apiCallWithAntiForgery,
  setAntiforgery,
  keepzApiCallWithAntiForgery,
  getKeepzPostInstace,
} from "./common";

// const requestToken = getCookieValue("XSRF-REQUEST-TOKEN");

async function sendSessionToken(tokenId) {
  return apiCallWithAntiForgery("post", `Auth/GetResult/${tokenId}`, {
    data: "Post",
  });
}

async function getBranches() {
  return getInstance(localToken()).get(`Reference/GetBranches`);
}

async function getCountryCodes() {
  return getInstance(localToken()).get(`/Reference/GetCountryCodes`);
}

async function getClientTypes() {
  return getInstance(localToken()).get("/Reference/GetClientTypes");
}
async function getAssets() {
  return getInstance(localToken()).get("/Reference/GetAssets");
}

async function getEmploymentStatuses() {
  return getInstance(localToken()).get("/Reference/GetEmploymentStatuses");
}

async function getEconomicalActivities() {
  return getInstance(localToken()).get("/Reference/GetEconomicActivities");
}

async function getActivitySubject() {
  return getInstance(localToken()).get("Reference/GetActivitySubjects");
}

async function GetIncomes() {
  return getInstance(localToken()).get("/Reference/GetIncomes");
}

async function getTaxClassifications() {
  return getInstance(localToken()).get("/reference/GetTaxClassifications");
}

async function getListDoubtfulCountries() {
  return getInstance(localToken()).get("/reference/GetListDoubtfulCountries");
}

async function GetMoneySources() {
  return getInstance(localToken()).get(`/reference/GetMoneySources`);
}

async function getPIMoneySources() {
  return getInstance(localToken()).get(`reference/GetMoneySourcesPI`);
}
async function getPIAccountPurposes() {
  return getInstance(localToken()).get(`reference/GetAccountPurposesPI`);
}
async function getPIIncomes() {
  return getInstance(localToken()).get(`/reference/GetIncomesPI`);
}
export async function verifyOtp(payload) {
  return keepzApiCallWithAntiForgery("post", `/onboarding/otp/verify`, payload);
}

export async function resendOtp(payload) {
  return keepzApiCallWithAntiForgery("post", `/onboarding/otp/resend`, payload);
}

export async function beginKeepzOnboarding(payload) {
  return keepzApiCallWithAntiForgery(
    "post",
    `/onboarding/keepz/begin`,
    payload
  );
}

export async function confirmKeepzOnBoarding(payload) {
  return keepzApiCallWithAntiForgery(
    "post",
    `/onboarding/keepz/result`,
    payload
  );
}

export async function getRemoteDataProcessingAgreement(locale) {
  return getInstance(localToken()).get(
    `Reference/GetRemoteDataProcAgreement/${locale}`
  );
}

export async function getTermsAgreement(locale) {
  return getInstance(localToken()).get(`Reference/GetTermsAgreement/${locale}`);
}

export async function getMarketingAgreement(locale) {
  return getInstance(localToken()).get(
    `Reference/GetMarketingAgreement/${locale}`
  );
}

export async function getVendors() {
  return getKeepzPostInstace(localToken()).get(`onboarding/active-vendors`);
}

const Services = {
  GetSecondAgreementText,
  getEconomicalActivities,
  getTaxClassifications,
  getActivitySubject,
  GetMonthlyTurnovers,
  GetIncomes,
  getEmploymentStatuses,
  getAuthLink,
  sendSessionToken,
  getPeps,
  getCountries,
  geCreditDebitCountries,
  getFullCountries,
  getCities,
  getCountryCodes,
  getPurposes,
  getClientTypes,
  getAssets,
  sendSmsTanCode,
  submitForm,
  submitPIForm,
  getAgreements,
  setAntiforgery,
  getBranches,
  getBanks,
  GetMoneySources,
  GetPropertieSources,
  getPepCategory,
  getListDoubtfulCountries,
  getPIAccountPurposes,
  getPIIncomes,
  getPIMoneySources,
  verifyIdentity,
  verifyOtp,
  resendOtp,
  beginKeepzOnboarding,
  getRemoteDataProcessingAgreement,
  getTermsAgreement,
  getMarketingAgreement,
  getVendors,
};

export default Services;
